export default __webpack_public_path__ + "static/media/manufacture-adv.7479fa5b.png";